import Cookies from "js-cookie";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { DEVICE, useWindowSizeChanged } from "@hooks/DeviceSize";
import { Container, Grid } from "@mui/material";

import LoaderContext from "@context/Loader/loaderContext";
import Loader from "@shared-containers/Loader";
import ErrorToast from "@constants/ErrorToast";
import LoginPageCard from "./LoginPageCard";
import LogoLoginPage from "./LogoLoginPage";
import {
  BackgroundImageMainWrapper,
  LoaderWrapper,
  LoginBackgroundImage,
  LoginBackgroundImageWrapper,
  LoginPageContainerWrapper,
  Wrapper,
} from "./style";

const SignInPage = () => {
  const device = useWindowSizeChanged();
  const isDesktop = device === DEVICE.DESKTOP;
  const navigate = useNavigate();
  const [{ loaderState }] = useContext(LoaderContext);

  const userData = Cookies.get("userData") || "";
  const parsedUserData = userData ? JSON.parse(userData) : null;
  const userToken: string | undefined = parsedUserData?.access_token;

  if (userToken) {
    navigate("/");
  }

  if (loaderState.loginLoader) {
    return (
      <LoaderWrapper>
        <Loader />
      </LoaderWrapper>
    );
  }

  return (
    <>
      <BackgroundImageMainWrapper>
        <LoginBackgroundImageWrapper>
          <LoginBackgroundImage />
        </LoginBackgroundImageWrapper>
      </BackgroundImageMainWrapper>
      <LoginPageContainerWrapper>
        <Container style={{ width: 375, maxHeight: 679, padding: "0px" }}>
          <Grid direction="column" container>
            <Grid style={{ marginTop: 150 }} item xs={12} sm={12} md={6} lg={6}>
              <LogoLoginPage isDesktop={isDesktop} />
            </Grid>
            <Grid style={{ marginTop: 64 }} item xs={12} sm={12} md={6} lg={6}>
              <Wrapper>
                <LoginPageCard />
              </Wrapper>
            </Grid>
          </Grid>
        </Container>
      </LoginPageContainerWrapper>
      <ErrorToast />
    </>
  );
};

export default SignInPage;
